function setWindowWidth() {
  const myWindowWidth = window.innerWidth;
  document.documentElement.style.setProperty('--sm-window-width', `${myWindowWidth}px`);
}

// Wait for the DOM to fully load before setting the initial window width
window.addEventListener('load', setWindowWidth);

// Update the window width whenever the window is resized
window.addEventListener('resize', setWindowWidth);


// Function to remove text when the page has finished loading
function removeTextOnLoad() {
  // Get the element with class "slider-arrow"
  var smSliderArrow = document.querySelector(".slider-arrow");

  // Remove the text by setting the innerHTML to an empty string
  smSliderArrow.innerHTML = "";
}

// Attach the function to the window.onload event
window.onload = removeTextOnLoad;